import { z } from 'zod';
import { ORGANIZATION_TABS } from './vocab';

export const ORGANIZATIONS_PAGE_SIZE = 25;

/** The queue's view, kept in the URL. Pending approval comes first. */
export const organizationsSearchSchema = z.object({
  status: z.enum(ORGANIZATION_TABS).default('pending').catch('pending'),
  q: z.string().trim().min(1).optional().catch(undefined),
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type OrganizationsSearch = z.output<typeof organizationsSearchSchema>;
